<template>
  <div>
    <div class="form-group" v-if="is_quick_add">
      <button class="btn btn-primary" @click="add_row_to_add" v-show="!is_add && !is_edit">Add</button>
    </div>
    <div class="form-group">
      <input type="text" class="form-control" v-model="search" @change="search_general" placeholder="Search"/>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th v-for="(data,index) in arr_header" :key="index" v-if="data != 'status delete'">
              <div class="d-flex justify-content-between" style="cursor: pointer;" @click="change_sort(index)">
                {{ data }}
                <i class="fas" :class="{'fa-sort': sort_by[index].sort == null, 'fa-sort-up': sort_by[index] != null && sort_by[index].sort == 'asc', 'fa-sort-down': sort_by[index] != null && sort_by[index].sort == 'desc', }"></i>
              </div>
            </th>
            <th v-if="url_detail != null || url_delete != null || is_quick_edit || is_action">Action</th>
          </tr>
        </thead>
        <tbody v-if="arr.length > 0">
          <tr v-if="arr.length > 0 && !is_edit && !is_add">
            <td v-for="(data,index) in arr_header" :key="index" v-if="data != 'status delete'">
              <div class="form-group">
                <input type="text" class="form-control" v-model="arr_search_specific[data]" @change="search_specific"/>
              </div>
            </td>
            <td v-if="url_detail != null || url_delete != null || is_action"></td>
          </tr>

          <tr v-for="(data,index) in arr_data" :key="'parent-'+index">
            <td v-for="(data1,index1) in data" :key="'sub-'+index1" v-if="index1 != 'status delete'">
              <div v-if="arr_is_edit.length > 0">
                <div v-show="!arr_is_edit[index]">{{ data1 }}</div>
                <div v-show="arr_is_edit[index]" class="form-group">
                  <input type="text" v-model="input_data[index][index1]" class="form-control"/>
                </div>
              </div>
              <div v-else>
                <div v-html="data1"></div>
              </div>
            </td>
            <td v-if="url_detail != null || url_delete != null || is_quick_edit || is_action">
              <div class="d-inline-block">
                <button class="btn btn-primary mr-2" v-show="!arr_is_edit[index] && is_quick_edit" @click="edit_view_action(index)">Edit</button>
                <button class="btn btn-danger mr-2" v-show="arr_is_edit[index]" @click="edit_view_action(index)">Cancel</button>
                <button class="btn btn-primary mr-2" v-show="arr_is_edit[index]" @click="!is_add ? quick_edit(index) : quick_add()">Save</button>
              </div>
              <div v-if="url_detail != null" class="d-inline-block">
                <a :href="url_detail+(url_detail_contain_question ? '&' : '?')+'id='+(data.id != null ? data.id : arr_data_id[index])" class="btn btn-primary mr-2" >View</a>
              </div>
              <button class="btn btn-danger mr-2" @click="delete_data(index)" v-show="(data['status delete'] == null && ((!is_add && !is_edit && url_delete != null) || (is_quick_edit && arr_is_edit.length > 0 && !arr_is_edit[index]))) || (data['status delete'] != null && data['status delete'] == 0)">{{ delete_text }}</button>
              <button class="btn btn-primary mr-2" @click="act_data(index)" v-show="(!is_add && !is_edit && is_action) || (is_action && is_quick_edit && arr_is_edit.length > 0 && !arr_is_edit[index])">{{ action_text }}</button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="url_detail != null || url_delete != null || is_quick_edit || is_action ? arr_header.length + 1 : arr_header.length" class="text-center">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
    <paginate
      v-if="total_page_data > 0"
      :pageCount="total_page_data"
      v-model="page"
      :clickHandler="change_page"
      prevText="Prev"
      nextText="Next"
      containerClass="pagination"
      page-class="page-item"
      page-link-class="page-link"
      prev-class="page-item"
      prev-link-class="page-link"
      next-class="page-item"
      next-link-class="page-link"/>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  props:{
    'arr':{
      type: Array,
      default: () => {
        return []
      },
    },
    'force_update':{
      type: String
    },
    'url_detail':{
      type: String
    },
    'url_delete':{
      type: String
    },
    'url_update':{
      type: String,
      default: '',
    },
    'url_quick_action':{
      type: String
    },
    'delete_text':{
      type: String,
      default: 'Delete',
    },
    'is_action':{
      type: Boolean,
      default: false,
    },
    'action_text':{
      type: String,
      default: 'Action',
    },
    'action_data':{
      type: String,
      default: 'Action',
    },
    'total_page':{
      type: Number
    },
    'is_quick_edit':{
      type: Boolean,
      default: false
    },
    'is_quick_add':{
      type: Boolean,
      default: false
    },
    'arr_id':{
      type: Array,
      default: () => {
        return []
      },
    },
    'arr_header':{
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components:{
    'paginate': Paginate,
  },
  created(){
    this.sort_by = []
    var arr_search_specific = this.arr_search_specific
    for(let x in this.arr_header){
      arr_search_specific[this.arr_header[x]] = ''
      var sort_by = {}
      sort_by.name = this.arr_header[x]
      sort_by.sort = null
      this.sort_by.push(sort_by)
    }
    this.arr_search_specific = arr_search_specific
    this.arr_header_data = this.arr_header
  },
  watch:{
    arr(value){
      if(value != null && !this.is_add){
        this.arr_data = value
        if(this.is_quick_edit){
          this.input_data = JSON.parse(JSON.stringify(this.arr))
          for(let x in this.input_data){
            this.arr_is_edit[x] = false
          }
        }
      }
    },
    force_update(value){
      this.page = 1
      this.get_data()
    },
    arr_id(value){
      this.arr_data_id = JSON.parse(JSON.stringify(this.arr_id))
    },
    arr_header(value){
      this.sort_by = []
      var arr_search_specific = this.arr_search_specific
      for(let x in value){
        arr_search_specific[value[x]] = ''
        var sort_by = {}
        sort_by.name = value[x]
        sort_by.sort = null
        this.sort_by.push(sort_by)
      }
      this.arr_search_specific = arr_search_specific
      this.arr_header_data = value

    },
    total_page(value){
      this.total_page_data = value
    }
  },
  data(){
    return{
      search: '',
      arr_search_specific: {},
      page: 1,
      input_data: [],
      arr_header_data: JSON.parse(JSON.stringify(this.arr_header)),
      arr_is_edit: [],
      is_edit: false,
      is_add: false,
      sort_by: [],
      arr_data: JSON.parse(JSON.stringify(this.arr)),
      arr_data_id: JSON.parse(JSON.stringify(this.arr_id)),
      total_page_data: this.total_page,
      url_detail_contain_question: this.url_detail != null && this.url_detail.search("\\?") != -1
    }
  },
  methods:{
    search_specific(){
      this.search = ''
      this.page = 1

      this.get_data()
    },
    search_general(){
      for(let x in this.arr_search_specific)
        this.arr_search_specific[x] = ''
      this.page = 1

      this.get_data()
    },
    change_sort(index){
      var sort = this.sort_by[index].sort == null ? 'asc' : (this.sort_by[index].sort == 'asc' ? 'desc' : null)
      var sort_by = this.sort_by[index]

      sort_by.sort = sort
      this.$set(this.sort_by,index,sort_by)

      this.get_data()
    },
    async get_data(){
      try{
        this.$emit('on_refresh_start')
        var url = this.url_update != '' ? this.url_update : this.url_delete
        // var regex =
        // console.log(url.find('?'))
        var response = await axios.get(base_url+url+(url.search("\\?") == -1 ? '?' : '&')+"search="+this.search+"&specific_search="+JSON.stringify(this.arr_search_specific)+"&sort="+JSON.stringify(this.sort_by)+"&api_type=web-admin&page="+this.page)

        this.$emit('on_refresh_end')
        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_data = response_data.arr
          this.arr_data_id = response_data.arr_id
          this.total_page_data = response_data.total_page
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    change_page(){
      this.get_data()
    },
    edit_view_action(index){
      this.$set(this.input_data,index,JSON.parse(JSON.stringify(this.arr_data[index])))
      this.$set(this.arr_is_edit,index,!this.arr_is_edit[index])

      if(!this.arr_is_edit[index]){
        if(this.is_add){
          this.arr_data.splice(0,1)
          this.input_data = JSON.parse(JSON.stringify(this.arr_data))
          this.is_add = false
        }
        this.is_edit = false
      }
      else
        this.is_edit = true
    },
    add_row_to_add(){
      if(this.arr_data.length > 0){
        var data = JSON.parse(JSON.stringify(this.arr_data[0]))

        for(let x in data)
          data[x] = ''
      }
      else{
        var data = {}
        for(let x in this.arr_header)
          data[this.arr_header[x]] = ''
      }

      this.arr_data.splice(0,0,data)
      this.input_data = JSON.parse(JSON.stringify(this.arr_data))
      this.arr_is_edit.splice(0,0,true)


      this.$set(this.input_data,0,JSON.parse(JSON.stringify(this.arr_data[0])))
      this.is_add = true
    },
    async quick_edit(index){
      var counter = 0
      var total = 0

      for(let x in this.input_data[index])
        total++

      for(let x in this.input_data[index]){
        if(this.input_data[index][x] == ''){
          this.$toasted.show(x+" is empty")
          break
        }
        counter++
      }

      if(counter == total){
        var data = {}
        data.id = this.arr_data_id[index]
        data.name = this.input_data[index].name

        var response = await axios.put(base_url+this.url_quick_action,data)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$set(this.arr_data,index,JSON.parse(JSON.stringify(this.input_data[index])))
          this.$set(this.arr_is_edit,index,!this.arr_is_edit[index])
          this.is_edit = false
          this.is_add = false
        }
      }
    },
    async quick_add(){
      var counter = 0
      var total = 0

      for(let x in this.input_data[0])
        total++

      for(let x in this.input_data[0]){
        if(this.input_data[0][x] == ''){
          this.$toasted.show(x+" is empty")
          break
        }
        counter++
      }

      if(counter == total){
        var data = {}
        data.name = this.input_data[0].name

        var response = await axios.post(base_url+this.url_quick_action,data)

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_data.push(JSON.parse(JSON.stringify(this.input_data[0])))
          this.arr_is_edit.push(false)
          this.$set(this.arr_is_edit,0,false)

          this.arr_data.splice(0,1)
          this.input_data = JSON.parse(JSON.stringify(this.arr_data))
          this.is_edit = false
          this.is_add = false

          this.page = 1
          this.search = ''
          this.get_data()
        }
      }
    },
    async delete_data(index){
      if(confirm('Are you sure?')){
        var id = this.arr_data[index].id == null ? this.arr_data_id[index] : this.arr_data[index].id
        var response = await axios.delete(base_url+this.url_delete+'?id='+id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.page = 1
          this.search = ''
          this.get_data()
        }
      }
    },
    async act_data(index){
      var data = this.arr_data[index]
      this.$emit('on_action',{data: data, action_data: this.action_data})
    }
  }
}
</script>
